const getters = {
  gameOver ({endTime, now}) {
    return now >= endTime
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js